var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{ref:"gamesButton",staticClass:"user-item-bottom",on:{"click":function($event){_vm.showGames = !_vm.showGames}}},[_vm._v(_vm._s(_vm.$t("myFriends.inviteGame")))]),_vm._v(" "),(_vm.showGames)?_c('InviteToGame',{directives:[{name:"click-outside",rawName:"v-click-outside",value:({
      exclude: ['gamesButton'],
      handler: 'clickOutsideGames',
    }),expression:"{\n      exclude: ['gamesButton'],\n      handler: 'clickOutsideGames',\n    }"}],staticClass:"friends-games invite",attrs:{"id":_vm.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }